var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 32 32",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: props.color,
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.589 3.768A12.942 12.942 0 0011 10c0 7.18 5.82 13 13 13 1.549 0 3.034-.27 4.411-.768A12.997 12.997 0 0117 29C9.82 29 4 23.18 4 16c0-5.631 3.58-10.426 8.589-12.232z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M16.25 9.392l-.147.06.012-.158-.103-.121.155-.038L16.25 9l.083.135.155.038-.103.12.012.16zM24 9.566l-.588.243.05-.634-.413-.484.618-.15L24 8l.333.542.618.149-.413.484.05.634zM19.5 12.783l-.294.122.025-.318-.207-.242.31-.074L19.5 12l.166.271.31.074-.207.242.025.318zM20 5.566l-.588.243.05-.634-.413-.484.618-.15L20 4l.333.542.618.149-.413.484.05.634z"
  }))));
}
export default SvgNight;